class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.init();
  }

  init() {
    const swiperContainer = this.querySelector('.custom-slider-swiper');
    if (!swiperContainer) return;

    // Get section settings from data attributes or use defaults
    const autoplay = this.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;
    
    // Default settings
    const settings = {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: false,
      autoplay: autoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 1,
          spaceBetween: 50,
        }
      }
    };

    // Initialize Swiper
    this.slider = new Swiper(swiperContainer, settings);

    // Handle autoplay if enabled
    if (settings.autoplay) {
      this.slider.autoplay.start();
    }

    // Add event listeners for navigation buttons
    const prevButton = this.querySelector('.custom-slider__nav--prev');
    const nextButton = this.querySelector('.custom-slider__nav--next');

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        this.slider.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        this.slider.slideNext();
      });
    }

    // Update navigation button states
    this.updateNavigationButtons();

    // Listen for slide changes
    this.slider.on('slideChange', () => {
      this.updateNavigationButtons();
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (this.slider) {
        this.slider.update();
      }
    });
  }

  updateNavigationButtons() {
    const prevButton = this.querySelector('.custom-slider__nav--prev');
    const nextButton = this.querySelector('.custom-slider__nav--next');

    if (prevButton) {
      if (this.slider.isBeginning) {
        prevButton.classList.add('swiper-button-disabled');
      } else {
        prevButton.classList.remove('swiper-button-disabled');
      }
    }

    if (nextButton) {
      if (this.slider.isEnd) {
        nextButton.classList.add('swiper-button-disabled');
      } else {
        nextButton.classList.remove('swiper-button-disabled');
      }
    }
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}

// Register the custom element
customElements.define('custom-slider', CustomSlider);

// Initialize existing sliders on page load
document.addEventListener('DOMContentLoaded', () => {
  const customSliders = document.querySelectorAll('.custom-slider');
  customSliders.forEach(slider => {
    if (!slider.classList.contains('custom-slider--initialized')) {
      slider.classList.add('custom-slider--initialized');
      new CustomSlider();
    }
  });
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const customSlider = event.target.querySelector('.custom-slider');
  if (customSlider && !customSlider.classList.contains('custom-slider--initialized')) {
    customSlider.classList.add('custom-slider--initialized');
    new CustomSlider();
  }
});

// Handle Shopify section unload
document.addEventListener('shopify:section:unload', (event) => {
  const customSlider = event.target.querySelector('.custom-slider');
  if (customSlider) {
    customSlider.classList.remove('custom-slider--initialized');
  }
});
